import * as React from 'react';
import './ShippingLabelToPrint.scss';
import { IReturnDetail, IStatusItem } from 'src/services/returns/typings';
import localeFormatingInstance from 'src/translation/localeFormating';
import i18n from 'src/translation/i18n';
import env from 'src/shared/env';

interface IContentToShippingLabelPrintProps {
  shippingLabel: any[];
}

class ShippingLabelToPrint extends React.Component<IContentToShippingLabelPrintProps, any> {
  public render() {
    return (
      <div className="rp-content-to-print">
        
        {this.props.shippingLabel && this.props.shippingLabel.map(img => (
          <div className="rp-content-to-print-row">
            <div className="container-fluid">
                  <p className="rp-content-to-print-row-content quantity text-center">
                  {env.REACT_APP_BASE_ENVIRONMENT === 'CA' ?
                  
                  <object data={img} type="application/pdf" style={{width: "100%",height: "100%"}} >
                  <embed src="https://qa.reliableparts.net/images/photos/returns/label/329039910198.pdf" type="application/pdf" style={{width: "100%",height: "100%"}} />
                  </object> 

                  :<img 
                  src={`${img}`}
                />
                  }
                  </p>
            </div>
          </div>
        ))}

       
      </div>
    );
  }
}

export default ShippingLabelToPrint;
